import React, { TouchEventHandler } from "react"
import NumberKeyPad from "../KeyPad/NumberKeyPad"

import { CSS_PROPERTY } from "../../features/Tablet/cssProperties/tablet"
import BackButton from "./BackButton"
import TenkosyaInfo from "./TenkosyaInfo"

const SelectSyainCode: React.FC<{
  value: string | undefined
  setValue: (value: string | undefined) => unknown
  onSubmit: TouchEventHandler<HTMLDivElement>
  backButtonAddProc?: (e: React.TouchEvent<HTMLDivElement>) => unknown
}> = React.memo((props) => {
  return (
    <>
      <TenkosyaInfo></TenkosyaInfo>

      <table
        style={{
          tableLayout: "fixed",
          height: CSS_PROPERTY.BODY_TABLE_HEIGHT,
          paddingBottom: "3rem",
        }}
        className="w-100">
        <tbody>
          <tr className="align-bottom">
            <td colSpan={2}>社員番号を入力してください。</td>
            <td style={{ fontSize: "2rem" }} className="text-center">
              <div
                className="d-inline-block text-start"
                style={{ width: "25rem" }}>
                社員番号
              </div>
            </td>
          </tr>
          <tr>
            <td className="align-bottom">
              <BackButton addProc={props.backButtonAddProc} />
            </td>
            <td
              style={{
                width: "40rem",
              }}>
              <div className="mx-auto">
                <NumberKeyPad value={props.value} setValue={props.setValue} />
              </div>
            </td>
            <td className="position-relative ">
              <div className="w-100 position-absolute top-0 text-center">
                <input
                  type="text"
                  style={{
                    width: "25rem",
                    marginTop: "0.5rem",
                    fontSize: CSS_PROPERTY.TABLET_FONT_SIZE,
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    backgroundColor: "white",
                  }}
                  value={props.value}
                  readOnly
                />
              </div>
              <div className="w-100 position-absolute bottom-0 text-center">
                <div
                  className="d-inline-block"
                  onTouchStart={props.onSubmit}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.WARN_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>確定</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
})

export default SelectSyainCode
